import script from "./VerifyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./VerifyPage.vue?vue&type=script&setup=true&lang=js"

import "./VerifyPage.vue?vue&type=style&index=0&id=460375c0&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/claims-portal/claims-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-460375c0"]])

export default __exports__